<template>
  <div class="scroll-wrapper" id="scrollWrapper">
    <iframe 
      v-if="detail" 
      :src="detail" 
      frameborder="0" 
      scrolling="yes"
      class="iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: String,
      default: null,
    },
  },
  mounted() {
  
  },
  methods: {
   
  }
}
</script>

<style scoped>
.scroll-wrapper {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.iframe {
  width: 100%;
  min-height: 110vh;
  border: none;
  display: block;
  position: relative;
}

</style>